import parsePhoneNumberFromString, { isSupportedCountry } from 'libphonenumber-js';
import type { SchemaEntry } from '../create-field-schema-registry';
import type { FieldSchemaFactoryParams } from '../types';
import { z } from 'zod';
import { ERRORS } from './errors';

export const phoneNumber = ({ country }: FieldSchemaFactoryParams) => z
  .string({ error: ERRORS.EMPTY })
  .superRefine((value, ctx) => {
    if (!value.trim()) {
      ctx.addIssue({ code: 'custom', message: ERRORS.EMPTY });
      return;
    }

    const upperCountry = country.toUpperCase();
    const parsed = isSupportedCountry(upperCountry)
      ? parsePhoneNumberFromString(value, { defaultCountry: upperCountry, extract: false })
      : undefined;

    if (!parsed || !parsed.isValid() || parsed.country !== upperCountry) {
      ctx.addIssue({ code: 'custom', message: ERRORS.INVALID_PATTERN });
    }
  });

export default ['phone_number', phoneNumber] as const satisfies SchemaEntry;
